module.exports = __webpack_public_path__ + "img/zendesk.8f50c42b.jpg";